import {
  generatePath,
  useMatch,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '@store';
import {
  useGetCreateGroupValidatorQuery,
  useLazyGetAccountsGroupsQuery,
} from '../../store/services/groups';
import { clearGroupsState } from '../../store/slices/groups';
import { clearPrimariesAccountsState } from '../../store/slices/primary-accounts';

import ROUTES from '../../../../routes';

const useList = () => {
  const { categoryId, groupId, primaryAccountId } = useParams();

  const navigate = useNavigate();

  const {
    categories: { categories },
    groups: { groups },
    accounts: { accounts },
  } = useAppSelector((state) => state.charts);
  const match = useMatch(ROUTES.PRIMARY_ACCOUNTS);
  const groupMatch = useMatch(ROUTES.GROUPS);

  const dispatch = useAppDispatch();

  useGetCreateGroupValidatorQuery();

  const [getAccountsGroups, { isLoading, isFetching }] =
    useLazyGetAccountsGroupsQuery();

  useEffect(() => {
    dispatch(clearGroupsState());
    dispatch(clearPrimariesAccountsState());

    if (categoryId) {
      getAccountsGroups(`all=true&categoryId=${categoryId}`);

      navigate(
        generatePath(ROUTES.PRIMARY_ACCOUNTS, {
          categoryId,
          groupId: groupId || 'groupId',
          primaryAccountId: primaryAccountId || 'primaryAccountId',
        }),
      );
    }
  }, [categoryId, dispatch]);

  useEffect(() => {
    if ((match || groupMatch) && categoryId && !isLoading && groups) {
      let group = 'groupId';
      let primary = 'primaryAccountId';

      if (groupId && groupId !== 'groupId') {
        group = groupId;
      } else if (groupId === 'groupId' && groups[0]) {
        group = groups[0]?.id;
      }

      if (
        primaryAccountId &&
        primaryAccountId !== 'primaryAccountId' &&
        accounts
      ) {
        primary = primaryAccountId;
      } else if (
        primaryAccountId === 'primaryAccountId' &&
        accounts &&
        accounts[0]
      ) {
        primary = accounts[0].id;
      }

      navigate(
        generatePath(ROUTES.PRIMARY_ACCOUNTS, {
          categoryId,
          groupId: group,
          primaryAccountId: primary,
        }),
        { replace: true },
      );
    }
  }, [
    groups,
    match,
    groupMatch,
    categoryId,
    isLoading,
    groupId,
    accounts,
    primaryAccountId,
  ]);

  return {
    categories,
    isLoading,
    isFetching,
    groups,
    categoryId,
    primaryAccountId,
    groupId,
  };
};

export default useList;
